import { BORDER_RADIUS_SM_PX } from '@/constants/colors';
import { Chip, ChipProps } from '@mui/material';

export const TagChip = ({ sx, ...rest }: ChipProps) => {
    return <Chip sx={{ ...sx, borderRadius: `${BORDER_RADIUS_SM_PX}px` }} {...rest} />;
};
